// API-Referenz: https://www.wix.com/velo/reference/api-overview/introduction
// „Hello, World!“ Beispiel: https://learn-code.wix.com/de/article/1-hello-world

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w('#elementID')

	// Click 'Preview' to run your code
});

